export default __webpack_public_path__ + "static/media/image-cover.34d374aa.png";